import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AuthHandler from "../../services/common/auth-handler";

const authHandler = AuthHandler();
const FIRST_REDIRECT_KEY = 'first-redirect';

const SessionExpiredPage = () => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        i18n.changeLanguage(authHandler.getLanguage());
    }, [i18n])

    useEffect(() => {
        authHandler.reset();
        window.localStorage.removeItem(FIRST_REDIRECT_KEY);
    }, [])

    return (
        <div className="height-100 d-flex flex-column justify-content-center align-items-center">
            <img
                alt="session expired"
                src={`${process.env.PUBLIC_URL}/images/session-expired.svg`} />
            <h1 className="c-dark-blue fw-semi-bold">{t("session_expired")}</h1>
            <div className="text-center w-75">
                <span className="c-dark-blue">
                   {t("session_content")}
                </span>
            </div>
        </div>);
}

export default SessionExpiredPage;